import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class H5Pager extends Vue {
    @Prop() page!: number
    @Prop() total!: number
    @Prop() per!: number

    public get ltBtn() {
        return this.total > this.per && this.page > 1
    }

    public get rtBtn() {
        return this.total > this.per && this.page < Math.ceil(this.total / this.per)
    }
    // 上一页/下一页
    public prev() {
        if (this.page === 1) return
        this.$emit('prev', this.page)
    }
    public next() {
        if (this.page >= Math.ceil(this.total / this.per)) return
        this.$emit('next', this.page)
    }
}